<script lang="ts">
  import { onMount } from "svelte"
  import { setCustomerImportStatusOrganizationId } from "../../../_shared/_logic/customer-import-status"

  const { organizationId } = $props<{
    organizationId: string | null
  }>()

  onMount(() => {
    setCustomerImportStatusOrganizationId(organizationId)

    return () => {
      setCustomerImportStatusOrganizationId(null)
    }
  })
</script>
